import './scss/vue-select.scss';

import {Vue} from "ui.vue";
import VueSelect from './components/Select.vue';
import mixins from './mixins/index';

Vue.component('VueSelect', VueSelect);

export default VueSelect;
export { VueSelect, mixins };